import * as React from 'react'

import { LpStateProvider } from './context/LpState'
import { VisitorTrackProvider } from './context/VisitorTrack'
import MetaPixel from './components/MetaPixel'

/**
 * Raiz compartilhada por gatsby-browser.js e gatsby-ssr.js.
 *
 * Os dois PRECISAM montar a mesma árvore: o HTML estático é gerado pelo lado
 * SSR e reidratado pelo lado browser. Provider só num deles = mismatch de
 * hidratação na primeira seção que ler a trilha.
 */
export const wrapRootElement = ({ element }) => (
  <VisitorTrackProvider>
    <LpStateProvider>
      <MetaPixel />
      {element}
    </LpStateProvider>
  </VisitorTrackProvider>
)
